package fyi.moko.hotpl.domain.service

/**
 * Thrown (carried as [Result.failure]) by [AuthService.linkWithGoogle] /
 * [AuthService.linkWithApple] when the OAuth credential the user is trying to
 * link is already bound to a *different* Firebase account.
 *
 * This is the Phase 3 "already have a social account on another device" path:
 * the current (usually freshly-issued anonymous) user cannot absorb the
 * credential, so the caller must instead **sign in** to the existing account
 * (via `signInWith*`), which changes the uid, and re-brand any local temp data
 * onto the new identity. See `LinkAccountUseCase` and
 * `docs/implementation_plan.md` §"Phase 3 Account Linking".
 */
class CredentialAlreadyInUseException(
    message: String = "This credential is already associated with a different account.",
    cause: Throwable? = null,
) : Exception(message, cause)
